import { AxiosInstance } from "../utils/AxiosInstance";

export const getReferralInvitationsPaginated = async (pagination: any) => {
  const { data } = await AxiosInstance.get(`/v1/referrals/invites`, {
    params: {
      limit: pagination.pageSize,
      offset: (pagination.current - 1) * pagination.pageSize,
    },
  });
  return data;
};
